import { cancelReserveRideSeat } from '../../services/customer/ticketBookingServices';

export default async function cancelSeatReserve(
  ride,
  statement,
  setChosenSeats,
  seat,
  wagonNumber,
) {
  const carriage = ride?.carriages?.find(
    (car) => `${car?.order_number}` === `${wagonNumber}`,
  ) ?? ride?.carriages?.[wagonNumber - 1]; const values = {
    statementGuid: statement?.guid,
    statementId: statement?.id,
    rideNumber: ride?.rideNumber,
    seatNumber: seat.seat_number,
    carriageId: carriage?.carriage_id,
    carriageOrderNumber: carriage?.order_number,
    seatGroupPropertyId: seat?.seat_group_property_id,
    seatGroupPropertyItemId: seat?.seat_group_property_item_id,
  };
  const response = await cancelReserveRideSeat(values);
  if (response.status === 'success') {
    setChosenSeats((prev) => {
      const arr = [...prev];
      return arr.filter(
        (item) => (
          !(item.carriage_id === values.carriageId && item.seat_number === values.seatNumber)
        ),
      );
    });
  }
}
